import * as React from "react";
import { cn } from "@/lib/utils";

const skeletonPulseClassName = "bg-muted rounded-md animate-pulse";

type BaseSkeletonProps = Omit<React.ComponentProps<"div">, "children" | "loading">;
export type SkeletonProps =
  | (BaseSkeletonProps & {
      children?: undefined;
      loading?: never;
    })
  | (BaseSkeletonProps & {
      loading: boolean;
      children: React.ReactNode;
    });

function Skeleton({ className, children, loading, ...props }: SkeletonProps) {
  if (children == null) {
    return <div data-slot="skeleton" className={cn(skeletonPulseClassName, className)} {...props} />;
  } else if (!loading) {
    return children;
  } else {
    return (
      <div data-slot="skeleton-slot" className={cn("relative min-w-0")} aria-busy={loading} {...props}>
        <div className={cn(loading && "invisible")} aria-hidden={loading || undefined}>
          {children}
        </div>
        {loading ? (
          <div data-slot="skeleton" className={cn(skeletonPulseClassName, "absolute inset-0", className)} />
        ) : null}
      </div>
    );
  }
}

Skeleton.displayName = "Skeleton";

export { Skeleton };
